import script from "./Complainces.vue?vue&type=script&setup=true&lang=js"
export * from "./Complainces.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Complainces.vue?vue&type=style&index=1&id=078bc488&lang=css"

const __exports__ = script;

export default __exports__